<template>
  <modal :title="i18n.t('/Configuration/Prompt/Title')" @close="goToDashboard">
    <form id="code-form" class="code-form" @submit.prevent="submit">
      <form-input
        id="configuration-code"
        v-model.trim.lazy="configurationCode"
        :show-label="false"
        :title="i18n.t('/Configuration/ConfigurationCode')"
        maxlength="50"
        type="text"
      />
      <app-button data-qa="open-configuration-code-button" :disabled="isLoading" type="submit"
        >{{ i18n.t('/Configuration/Prompt/OpenButtonText') }} <loader v-if="isLoading"
      /></app-button>
      <app-button
        button-class="button primary button--configurator"
        data-qa="open-configurator-button"
        @click="openConfigurator"
      >
        <icon icon="configurator" />
        {{ i18n.t('/Configuration/Prompt/ConfiguratorButtonText') }}
        <icon icon="angle-right" />
      </app-button>
    </form>
    <alert type="info" :text="infoText" />
  </modal>
</template>

<script>
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import ConfigurationHelper from '@/helpers/ConfigurationHelper'

export default {
  components: {
    FormInput,
    AppButton,
    Modal,
    Icon,
    Alert,
    Loader,
  },
  props: {
    code: {
      type: String,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit', 'close'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      configurationCode: '',
    }
  },
  computed: {
    infoText() {
      const key = '/Configuration/Prompt/InfoText'
      return !this.i18n.t(key) || this.i18n.t(key) !== key ? this.i18n.t(key) : null
    },
    configuratorUrl() {
      return this.i18n.t('/Configuration/ConfiguratorUrl') + this.configuratorCallbackUrl
    },
    configuratorCallbackUrl() {
      const route = {
        name: 'configurator-callback',
        ...ConfigurationHelper.generateConfigurationRoute(this.$route.params, this.$route.query),
      }

      const relativeUrl = this.$router.resolve(route).href
      return `?carsalestool=true&returnUrl=${encodeURIComponent(
        window.location.origin + relativeUrl
      )}`
    },
  },

  mounted() {
    this.configurationCode = this.code
  },

  methods: {
    submit() {
      this.$emit('submit', this.configurationCode)
    },
    openConfigurator() {
      if (this.i18n.t('/Configuration/ConfiguratorUrlTarget') == '_blank') {
        window.open(this.configuratorUrl)
      } else {
        location.href = this.configuratorUrl
      }
    },
    goToDashboard() {
      this.$emit('close')
      this.$router.push({
        name: `quote-overview-page`,
        params: {
          cstType: this.$route.params.cstType,
          establishmentId: this.$route.params.establishmentId,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.code-form {
  display: flex;
}

.fieldset-inline {
  display: inline;
}

.fixedheight-btn {
  height: 44px;
  vertical-align: middle;
}

.button--configurator {
  margin-left: 1em;
}
</style>
>
